/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { labels } from "../../../../api/Api";

export const getAllLabels = createAsyncThunk(
  "appLabels/getAllLabels",
  async () => {
    try {
      return labels.getAll();
    } catch (error) {
      console.error(error);
    }
  }
);

export const getLabel = createAsyncThunk("appLabels/getLabel", async (id) => {
  try {
    return labels.getLabel(id);
  } catch (error) {
    console.error(error);
  }
});

export const addLabels = createAsyncThunk(
  "appLabels/addLabels",
  async (values) => {
    try {
      return labels.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteLabels = createAsyncThunk(
  "appLabels/deleteLabels",
  async (id) => {
    return labels.deleteItem(id);
  }
);

export const editLabel = createAsyncThunk(
  "appLabel/editLabel",
  async (values) => {
    return labels.edit(values);
  }
);

export const appLabelsSlice = createSlice({
  name: "appLabels",
  initialState: {
    labels: [],
    isFetchedLabels: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllLabels.fulfilled, (state, action) => {
        state.labels = action.payload?.data?.data;
        state.isFetchedLabels = true;
      })
      .addCase(deleteLabels.fulfilled, (state, action) => {
        state.isFetchedLabels = false;
      })
      .addCase(editLabel.fulfilled, (state, action) => {
        state.isFetchedLabels = false;
      })
      .addCase(addLabels.fulfilled, (state, action) => {
        state.isFetchedLabels = false;
      });
  },
});

export default appLabelsSlice.reducer;
